import { render } from "./Country.vue?vue&type=template&id=56f55708&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"

import "./Country.vue?vue&type=style&index=0&id=56f55708&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f55708"]])

export default __exports__